import { render, staticRenderFns } from "./layHeads.vue?vue&type=template&id=08d44cec&scoped=true"
import script from "./layHeads.vue?vue&type=script&lang=js"
export * from "./layHeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d44cec",
  null
  
)

export default component.exports